module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[102]101.90517f8.woff2";